import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import LocalStorageService from 'web-app/services/local-storage';

import * as Api from './api';
import * as Actions from './actions';

const fetchLogins = action$ =>
    action$.ofType(Actions.fetchLogins.type).mergeMap(() => {
        return Api.fetchAccountsForLogin(LocalStorageService.getFromLocalStorage('deviceId'))
            .map(result => {
                return Actions.fetchLoginsSuccess.action(result);
            })
            .catch(e => Observable.of(Actions.fetchLoginsFailed.action(e)));
    });

export default combineEpics(fetchLogins);
